var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRuleViolationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_493_66567)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.7204 22.211L56.0483 22.3242L54.547 13.2536C54.4323 12.561 53.8348 12.0533 53.1355 12.0533H6.88284C6.28345 12.0533 5.71312 12.3172 5.32402 12.7753C4.93514 13.2343 4.76622 13.8405 4.86077 14.4338L9.97798 46.4534C10.2678 48.2691 11.5047 49.6185 13.3368 49.6185H60.1018L60.1008 50.3029H13.3367C11.1527 50.3029 9.6503 48.7263 9.30503 46.5628L4.18691 14.5433C4.0603 13.7513 4.28699 12.9427 4.8058 12.332C5.32461 11.7212 6.08374 11.3689 6.88384 11.3689H53.1356C54.1694 11.3689 55.0498 12.1185 55.2193 13.1414L56.7204 22.211Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7275 26.0303C43.4672 30.9159 44.2068 35.8014 44.9464 40.687L42.7275 26.0303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7373 17.199H5.18701V17.8835H55.7373V17.199Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.88845 13.3799C8.64696 13.3799 9.26274 13.9984 9.26274 14.7587C9.26274 15.5204 8.64696 16.139 7.88845 16.139C7.12994 16.139 6.51416 15.5204 6.51416 14.7587C6.51416 13.9984 7.12994 13.3799 7.88845 13.3799ZM7.88845 14.0634C7.50611 14.0634 7.19579 14.3748 7.19579 14.7587C7.19579 15.144 7.50611 15.4555 7.88845 15.4555C8.27079 15.4555 8.58111 15.144 8.58111 14.7587C8.58111 14.3748 8.27079 14.0634 7.88845 14.0634Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.531 13.3799C12.2895 13.3799 12.9053 13.9984 12.9053 14.7587C12.9053 15.5204 12.2895 16.139 11.531 16.139C10.7725 16.139 10.1567 15.5204 10.1567 14.7587C10.1567 13.9984 10.7725 13.3799 11.531 13.3799ZM11.531 14.0634C11.1487 14.0634 10.8384 14.3748 10.8384 14.7587C10.8384 15.144 11.1487 15.4555 11.531 15.4555C11.9134 15.4555 12.2237 15.144 12.2237 14.7587C12.2237 14.3748 11.9134 14.0634 11.531 14.0634Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1741 13.3799C15.9326 13.3799 16.5484 13.9984 16.5484 14.7587C16.5484 15.5204 15.9326 16.139 15.1741 16.139C14.4156 16.139 13.7998 15.5204 13.7998 14.7587C13.7998 13.9984 14.4156 13.3799 15.1741 13.3799ZM15.1741 14.0634C14.7918 14.0634 14.4814 14.3748 14.4814 14.7587C14.4814 15.144 14.7918 15.4555 15.1741 15.4555C15.5564 15.4555 15.8668 15.144 15.8668 14.7587C15.8668 14.3748 15.5564 14.0634 15.1741 14.0634Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9535 51.1064L28.5574 51.423L23.1414 61.8606C22.8778 62.3714 22.8965 62.9841 23.1945 63.4761C23.4925 63.9697 24.023 64.269 24.5973 64.269H44.6288V64.9538H24.5973C23.7859 64.9538 23.0322 64.5291 22.6125 63.8318C22.1912 63.1345 22.1631 62.268 22.5376 61.5456L27.9535 51.1064Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7645 50.9355L30.3699 51.2521L24.7839 62.0188C24.6872 62.2037 24.695 62.4262 24.8026 62.6048C24.9103 62.785 25.1038 62.8931 25.3129 62.8931H47.0655V63.5779H25.3129C24.8666 63.5779 24.4516 63.3444 24.2206 62.9605C23.9881 62.5766 23.9725 62.1002 24.1801 61.7022L29.7645 50.9355Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1188 50.9385L41.7258 51.2487L35.5812 63.3912L34.9727 63.081L41.1188 50.9385Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.3209 51.0923H30.0883L28.8628 53.5685H40.1097L41.3209 51.0923Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9429 43.9739C54.1167 45.0745 53.3303 46.0428 52.2107 46.0428H22.0788C20.9315 46.0428 19.8725 45.1075 19.6933 43.9739C17.5014 30.1237 15.3109 16.2735 13.1203 2.4233C12.9464 1.3227 13.7328 0.355713 14.8524 0.355713H44.983C46.1316 0.355713 47.1907 1.29095 47.3698 2.4233C49.5604 16.2735 51.751 30.1237 53.9429 43.9739Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.1972 43.9342C54.3961 45.1949 53.4938 46.3008 52.2108 46.3008H22.0789C20.8104 46.3008 19.6368 45.2676 19.4392 44.0149L12.8662 2.46438C12.666 1.20371 13.5696 0.0964355 14.8526 0.0964355H44.9831C46.2529 0.0964355 47.4253 1.13091 47.6242 2.38364L54.1972 43.9342ZM53.6888 44.0149L47.1157 2.46438C46.955 1.45108 46.0092 0.613689 44.9831 0.613689H14.8526C13.8949 0.613689 13.2258 1.4431 13.3746 2.38364L19.9477 43.9342C20.1084 44.9462 21.0528 45.7835 22.0789 45.7835H52.2108C53.1671 45.7835 53.8376 44.9554 53.6888 44.0149Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3485 36.4834H22.2178V37.0004H48.3485V36.4834Z",
    fill: "#DFE1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6679 38.8911H22.5991V39.4081H46.6679V38.8911Z",
    fill: "#DFE1E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8704 32.0322L35.4766 31.7L36.0049 31.0687C37.3954 29.4087 39.9104 29.742 41.4072 31.0398H41.4083C42.1022 31.6412 43.0009 32.0247 43.9237 32.0247C44.7397 32.0247 45.5479 31.7032 46.0788 31.0697L46.0962 31.0484C46.7203 30.3038 47.667 29.9182 48.6264 29.9182V30.4352C47.8175 30.4352 47.0163 30.7536 46.4901 31.3817L46.4728 31.403C45.8439 32.1529 44.8903 32.5417 43.9237 32.5417C42.8782 32.5417 41.8581 32.1134 41.072 31.4319L41.0708 31.4308C39.7765 30.3092 37.6014 29.9652 36.3988 31.402L35.8704 32.0322Z",
    fill: "#DFE1E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8548 32.1943L21.4609 31.8621L21.9893 31.2308C23.3798 29.5708 25.8947 29.9041 27.3915 31.2019H27.3927C28.0865 31.8033 28.9852 32.1868 29.9081 32.1868C30.7241 32.1868 31.5323 31.8653 32.0632 31.2318L32.0806 31.2105C32.7047 30.4659 33.6513 30.0803 34.6108 30.0803V30.5973C33.8019 30.5973 33.0007 30.9157 32.4745 31.5438L32.4572 31.5651C31.8283 32.315 30.8746 32.7038 29.9081 32.7038C28.8626 32.7038 27.8424 32.2755 27.0564 31.594L27.0552 31.5929C25.7608 30.4713 23.5857 30.1273 22.3831 31.5641L21.8548 32.1943Z",
    fill: "#DFE1E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.6955 3.54346C35.2001 3.54346 25.7048 3.54346 16.2095 3.54346C17.4323 11.2757 18.6551 19.0066 19.8779 26.7389C29.3732 26.7389 38.8699 26.7389 48.3652 26.7389C47.1411 19.0066 45.9183 11.2757 44.6955 3.54346Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.9494 3.50362L48.6191 26.6977C48.631 26.7721 48.6085 26.8492 48.5609 26.9064C48.5119 26.9635 48.4391 26.9967 48.365 26.9967H19.8777C19.752 26.9967 19.6435 26.905 19.6236 26.7788L15.9538 3.58467C15.9432 3.50892 15.9644 3.43312 16.0134 3.37598C16.0624 3.31883 16.1338 3.28564 16.2093 3.28564H44.6953C44.8223 3.28564 44.9295 3.37737 44.9494 3.50362ZM44.4756 3.80265H16.5097L20.0974 26.4797H48.0633L44.4756 3.80265Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4328 15.2957C25.8187 11.4385 28.5189 8.22778 32.4085 8.22778C36.3955 8.22778 39.9926 11.3406 40.6262 15.2957C41.2306 19.1136 38.4329 22.2268 34.6213 22.2268C30.7025 22.2268 27.047 19.2115 26.4328 15.2957Z",
    fill: "#9E007E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0156 13.109L29.8781 11.8287L38.0534 17.354L37.1903 18.6353L29.0156 13.109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6502 10.6992L36.9277 11.562L31.4183 19.7644L30.1399 18.9008L35.6502 10.6992Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_493_66567"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 65,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuleViolationIcon);
export default __webpack_public_path__ + "static/media/rule-violation-icon.da5486df52c2ab45c9b7b6e1e19b6111.svg";
export { ForwardRef as ReactComponent };